import Grid from "@mui/material/Grid";
import { NavLink } from "react-router-dom";
import Container from "@mui/material/Container";
import { Paper } from "@mui/material";

function FleetManagement() {
  return (
    <div className="container">
      <h1>Fleet Management</h1>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper>
            <Container>
              <h2>Reports</h2>
              <NavLink to="/fleet/communictaing">
                Communicating But Not Registered
              </NavLink>
              <br />
              <NavLink to="/fleet/badshutties/report">
                Shuttie Comms Issue Tracking
              </NavLink>
              <br />
              <NavLink to="/fleet/flowieozero">
                Flowie-Os Reporting Zero
              </NavLink>
              <br />
              <NavLink to="/fleet/fleetstatus">Fleet Status Report</NavLink>
              <br />
              <NavLink to="/fleet/fleetstatus/offline">
                Fleet Status Report (Offline)
              </NavLink>
              <br />
              <NavLink to="/fleet/waterkernelinit">
                Water Kernel Initialization Report
              </NavLink>
              <br />
              <NavLink to="/fleet/waterkernelunique">
                Water Kernel Unique Devices
              </NavLink>
              <br />
              <NavLink to="/fleet/eventspammers">Event Spammers Report</NavLink>
              <br />
              <NavLink to="/fleet/zoneratioswitch">
                Zone Ratio Switch Report
              </NavLink>
              <br />
              <NavLink to="/fleet/sadwaterdevices">Sad Water Devices</NavLink>
              <br />
              <NavLink to="/fleet/logsvsvitals">Logs Vs Vitals</NavLink>
              <br />
              <br />
              <h3>Users</h3>
              <NavLink to="/fleet/users/report">Users Report</NavLink>
              <br />
              <h3>SIMs</h3>
              <NavLink to="/fleet/sims/usage">Sim Usage</NavLink>
              <br />
              <br />
            </Container>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default FleetManagement;
